// HomePage.js
import React from 'react';
import Loader from '../components/loader';
import HomeBanner from '../components/HomeBanner';
import HeroAbout from '../components/HeroAbout';
// import UserCount from '../components/UserCount';
import Activities from '../components/Activities';
import LatestCourse from '../components/latestCourse';
import MetaTags from '../common-components/MetaTags';
import VideoPlayer from '../components/VideoPlay';
import HomeTeamPage from '../components/HomeTeamPage';

// import Events from '../components/Events';
// import Sermons from '../components/Sermons';
// import Blog from '../components/Blog';
// import Team from '../components/Team';
// import Testimonial from '../components/Testomonial';
// import axios from 'axios';
// import Course from '../components/course';

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      aboutUsData: []
    };
  }
  
  componentDidMount() {
    // document.title = "Home - Learn Quran Easily";
    // const metaDescription = document.querySelector("meta[name='description']");
    // const content = "Learn about our mission, vision, and mosque activities.";
    // if (metaDescription) {
    //   metaDescription.setAttribute("content", content);
    // } else {
    //   const meta = document.createElement("meta");
    //   meta.name = "description";
    //   meta.content = content;
    //   document.head.appendChild(meta);
    // }

      setTimeout(() => {
        this.setState({ loading: false });
      }, 100); // Simulate a 3-second loading delay
  }

  
  render() {
    const aboutData = {
      aboutTitle: {
        text: "About THEMosque",
        images: [
          { src: "img/about-1.jpg", alt: "About Image 1"},
          { src: "img/about-2.jpg", alt: "About Image 2"},
          { src: "img/about-3.jpg", alt: "About Image 3" }
        ]
      },
      bannerText: "Allah Help Those Who Help Themselves",
      visionText: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam. Etiam quis mauris justo.",
      missionText: "Lorem ipsum dolor sit amet tetur nod elit sed.",
      childImage: {
        src: "img/about-child.jpg",
        alt: "About Child",
        description: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam."
      },
      raisedAmount: "20,46",
      services: [
        "Charity & Donation",
        "Parent Education",
        "Hadith & Sunnah",
        "Mosque Development"
      ],
      additionalBannerText: "Every Muslim Needs To Realise The Importance Of The 'Pillar' Of Islam",
      buttonText: "Learn More"
    };

    const activitiesData = [
      {
        title: "Mosque Development",
        icon: "mosque",
        description: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam.",
        link: "/mosque-development",
        linkText: "Read More"
      },
      {
        title: "Charity & Donation",
        icon: "donate",
        description: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam.",
        link: "/charity-donation",
        linkText: "Read More"
      },
      {
        title: "Quran Learning",
        icon: "quran",
        description: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam.",
        link: "/quran-learning",
        linkText: "Read More"
      },
      {
        title: "Hadith & Sunnah",
        icon: "book",
        description: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam.",
        link: "/hadith-sunnah",
        linkText: "Read More"
      },
      {
        title: "Parent Education",
        icon: "book-open",
        description: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam.",
        link: "/parent-education",
        linkText: "Read More"
      },
      {
        title: "Help Orphans",
        icon: "hands",
        description: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam.",
        link: "/help-orphans",
        linkText: "Read More"
      }
    ];

    // const eventsData = [
    //   {
    //     date: "01 Jan 2045",
    //     time: "Fri 06:55",
    //     title: "Milad Un Nabi",
    //     description:
    //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     link: "#",
    //     buttonText: "Join Now",
    //     image: "img/events-1.jpg"
    //   },
    //   {
    //     date: "01 Jan 2045",
    //     time: "Wed 11:30",
    //     title: "Eid Ul Fitr",
    //     description:
    //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     link: "#",
    //     buttonText: "Join Now",
    //     image: "img/events-2.jpg"
    //   },
    //   {
    //     date: "01 Jan 2045",
    //     time: "Thu 11:30",
    //     title: "Eid Ul Azha",
    //     description:
    //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     link: "#",
    //     buttonText: "Join Now",
    //     image: "img/events-3.jpg"
    //   }
    // ];

    // const sermonsData = [
    //   {
    //     image: "img/sermon-1.jpg",
    //     date: "13 Nov 2023",
    //     author: "Admin",
    //     title: "How to get closer to Allah",
    //     description:
    //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, aliquip ex ea commodo consequat.",
    //     dateLink: "#",
    //     authorLink: "#",
    //     link: "#",
    //     links: [
    //       { icon: "fa-video", url: "#" },
    //       { icon: "fa-headphones", url: "#" },
    //       { icon: "fa-file-alt", url: "#" },
    //       { icon: "fa-image", url: "#" }
    //     ]
    //   },
    //   {
    //     image: "img/sermon-2.jpg",
    //     date: "13 Nov 2023",
    //     author: "Admin",
    //     title: "Importance of Hajj in Islam",
    //     description:
    //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, aliquip ex ea commodo consequat.",
    //     dateLink: "#",
    //     authorLink: "#",
    //     link: "#",
    //     links: [
    //       { icon: "fa-video", url: "#" },
    //       { icon: "fa-headphones", url: "#" },
    //       { icon: "fa-file-alt", url: "#" },
    //       { icon: "fa-image", url: "#" }
    //     ]
    //   },
    //   {
    //     image: "img/sermon-3.jpg",
    //     date: "13 Nov 2023",
    //     author: "Admin",
    //     title: "Importance of ‘Pillar’ of Islam",
    //     description:
    //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, aliquip ex ea commodo consequat.",
    //     dateLink: "#",
    //     authorLink: "#",
    //     link: "#",
    //     links: [
    //       { icon: "fa-video", url: "#" },
    //       { icon: "fa-headphones", url: "#" },
    //       { icon: "fa-file-alt", url: "#" },
    //       { icon: "fa-image", url: "#" }
    //     ]
    //   }
    // ];

    // const blogData = [
    //   {
    //     image: "img/blog-1.jpg",
    //     date: "01 Jan 2045",
    //     author: "Admin",
    //     authorLink: "#",
    //     commentLink: "#",
    //     comments: 12,
    //     title: "Importance of ‘Pillar’ of Islam",
    //     description:
    //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, aliquip ex ea commodo consequat.",
    //     link: "#",
    //     bookmarkLink: "#"
    //   },
    //   {
    //     image: "img/blog-2.jpg",
    //     date: "01 Jan 2045",
    //     author: "Admin",
    //     authorLink: "#",
    //     commentLink: "#",
    //     comments: 12,
    //     title: "How to get closer to Allah",
    //     description:
    //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, aliquip ex ea commodo consequat.",
    //     link: "#",
    //     bookmarkLink: "#"
    //   },
    //   {
    //     image: "img/blog-3.jpg",
    //     date: "01 Jan 2045",
    //     author: "Admin",
    //     authorLink: "#",
    //     commentLink: "#",
    //     comments: 12,
    //     title: "Importance of Hajj in Islam",
    //     description:
    //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, aliquip ex ea commodo consequat.",
    //     link: "#",
    //     bookmarkLink: "#"
    //   }
    // ];
    // const teamData = [
    //   {
    //     image: "img/team-1.jpg",
    //     name: "Anamul Hasan",
    //     role: "President",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     socialLinks: [
    //       { icon: "fab fa-facebook-f", url: "#" },
    //       { icon: "fab fa-twitter", url: "#" },
    //       { icon: "fab fa-instagram", url: "#" },
    //       { icon: "fab fa-linkedin-in", url: "#" },
    //     ],
    //     sizeLg: 4,
    //     sizeXl: 5
    //   },
    //   {
    //     image: "img/team-2.jpg",
    //     name: "Mustafa Kamal",
    //     role: "Imam",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     socialLinks: [
    //       { icon: "fab fa-facebook-f", url: "#" },
    //       { icon: "fab fa-twitter", url: "#" },
    //       { icon: "fab fa-instagram", url: "#" },
    //       { icon: "fab fa-linkedin-in", url: "#" },
    //     ],
    //     sizeLg: 4,
    //     sizeXl: 4
    //   },
    //   {
    //     image: "img/team-3.jpg",
    //     name: "Nahiyan Momen",
    //     role: "Teacher",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     socialLinks: [
    //       { icon: "fab fa-facebook-f", url: "#" },
    //       { icon: "fab fa-twitter", url: "#" },
    //       { icon: "fab fa-instagram", url: "#" },
    //       { icon: "fab fa-linkedin-in", url: "#" },
    //     ],
    //     sizeLg: 4,
    //     sizeXl: 4
    //   },
    //   {
    //     image: "img/team-4.jpg",
    //     name: "Asfaque Ali",
    //     role: "Volunteer",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     socialLinks: [
    //       { icon: "fab fa-facebook-f", url: "#" },
    //       { icon: "fab fa-twitter", url: "#" },
    //       { icon: "fab fa-instagram", url: "#" },
    //       { icon: "fab fa-linkedin-in", url: "#" },
    //     ],
    //     sizeLg: 4,
    //     sizeXl: 4
    //   }
    // ];
    // const testimonials = [
    //   {
    //     name: 'John Doe',
    //     profession: 'Software Engineer',
    //     image: 'img/testimonial-1.jpg',
    //     feedback: 'Islam has taught me peace and patience in all aspects of life.',
    //   },
    //   {
    //     name: 'Jane Smith',
    //     profession: 'Doctor',
    //     image: 'img/testimonial-2.jpg',
    //     feedback: 'The teachings of Islam have helped me grow spiritually and mentally.',
    //   },
    //   {
    //     name: 'Ahmed Khan',
    //     profession: 'Teacher',
    //     image: 'img/testimonial-3.jpg',
    //     feedback: 'I found great wisdom in the Quran and its teachings, bringing me closer to Allah.',
    //   },
    //   {
    //     name: 'Fatima Zainab',
    //     profession: 'Entrepreneur',
    //     image: 'img/testimonial-4.jpg',
    //     feedback: 'Islam has given me clarity of purpose and direction in life.',
    //   },
    // ]
    return <>
    <MetaTags
          title="Home - Learn Quran Easily"
          description="Learn about our mission, vision, and mosque activities."
          keywords="Quran, Islamic Learning, Online Classes, LQE"
          author="LQE Team"
          url="https://learnquraneasily.in/"
          image="https://lqe-assets.learnquraneasily.in/1747284949484_Lqe_logo.png"
        />

      {this.state.loading ? <Loader /> :
        <>
          <HomeBanner
            welcomeMessage="WELCOME TO LQE"
            bannerTitle="Purity Comes From Faith"
            buttonText="Read More"
            buttonUrl="/"
            bgImage="/img/hero.jpg"
          />
          {/* <UserCount /> */}
          <HeroAbout {...aboutData} />
          <VideoPlayer />
          <HomeTeamPage />
          <LatestCourse />
          {/* <Blog blogData={blogData} /> */}
          <Activities activitiesData={activitiesData} />
          
          {/* <Events eventsData={eventsData} /> */}
          {/* <Sermons sermonsData={sermonsData} />
          <Team teamData={teamData} /> */}
          {/* <Testimonial testimonials={testimonials} /> */}
        </>}
    </>
  }
}


export default HomePage;
